export default __webpack_public_path__ + "static/waterfallplaceholder-adc3c648eae1d43fd3470e9d8f1f18a2.jpg";